import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import { PER_PAGE } from '../../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function BuzzPagination({
  onClick,
  total,
  pageNo = 1,
  defaultPage = 1,
  perPage = PER_PAGE,
}) {
  const classes = useStyles();

  const noOfPages = Math.ceil(total / perPage);

  const handleOnClick = (_e, val) => {
    if (typeof onClick === 'function' && val !== pageNo) {
      onClick(val);
    }
  };

  return (
    <div className={classes.root}>
      <Pagination
        color="primary"
        onChange={handleOnClick}
        count={noOfPages}
        variant="outlined"
        shape="rounded"
        page={pageNo}
        defaultPage={defaultPage}
      />
    </div>
  );
}
